import styled from "styled-components"
import { Flex, IconWrapper } from "../../../../styles/CommonStyles"
import { FaDownload } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { downloadImage } from "../../../../core/utils/common";


const AttachmentItem = ({ att, ...rest }) => {

    return (
        <Wrapper {...rest}>
            <Flex fw fh justify={'space-between'}>
                <Truncate>
                    {att.name}
                </Truncate>

                <Flex style={{ gap: 4 }}>
                    <IconWrapper padding={'8px'} onClick={() => downloadImage(att.link, att.name)}>
                        <DownloadIcon size={14} />
                    </IconWrapper>
                    <a href={att.link} target={'_blank'} rel={"noreferrer"}>
                        <IconWrapper padding={'8px'}>
                            <EyeIcon size={14} />
                        </IconWrapper>
                    </a>
                </Flex>
            </Flex>
        </Wrapper>
    )
}


const Wrapper = styled.div`
    border: 1px solid ${props => props.theme.color}40;
    border-radius: 12px;
    width: '244px';
    height: 52px;
    background-color: ${props => props.theme.primaryBg};
    padding: 0px 12px;
`

const Truncate = styled.span`
    overflow: hidden;
    margin-top: 4px;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.8rem;
    color: ${props => props.theme.color};
    max-width: 164px;
`

const DownloadIcon = styled(FaDownload)`
    color: ${props => props.theme.color};
`

const EyeIcon = styled(FaEye)`
    color: ${props => props.theme.color};
`

export default AttachmentItem